// extracted by mini-css-extract-plugin
export var box = "_4i-0";
export var check = "_4i-1";
export var checkboxButton = "_4i-6";
export var checkboxGroup = "_4i-5";
export var disabled = "_4i-7";
export var ghost = "_4i-9";
export var input = "_4i-2";
export var label = "_4i-4";
export var normal = "_4i-8";
export var uncheck = "_4i-3";